// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KunI","newExpiryDate":"styles_newExpiryDate__3OKVK","footer":"styles_footer__3zJyt"};